import {HeaderDiv, TextDiv, LargeHeaderTitle, SmallTextDiv} from './styled-components';

export {
  HeaderDiv,
  TextDiv,
  LargeHeaderTitle,
  SmallTextDiv
};



// WEBPACK FOOTER //
// ./src/modals/index.js